import { createV3Queries } from "@query/utils/createV3Queries";
import { workDefinitionsApi } from "@api";

/**
 * Work-definition (template) registry — mirrors `WorkDefinitionsApi` 1:1. The
 * name-derived defaults refresh the sibling reads (`getWorkDefinition` /
 * `listWorkDefinitions`) after every write, which is all the v1 hooks did.
 *
 * DEPLOY RISK: the standalone `/v3/payments/work-definitions` list/picker has
 * been observed returning 501 during earlier migrations (see
 * V3_MIGRATION_TRACKER.md). Migrated on SDK-as-truth per the migration decision;
 * BE must confirm the endpoint is deployed.
 */
export const queriesWorkDefinitions = createV3Queries(
  "workDefinitionsApi",
  workDefinitionsApi
);
